import { Routes, Route } from "react-router-dom";
import Login from "./Authentication/Login";
import Logout from "./Authentication/Logout";
import Profile from "./Authentication/Profile";
import Category from "./Components/Masters/Category";
import ClientService from "./Components/Services/ClientService";
import Designation from "./Components/Staff-info/Designation";
import Staff from "./Components/Staff-info/Staff";
import OverTime from "./Components/Staff-info/OverTime";
import Salary from "./Components/Staff-info/Salary";
import AttendanceReport from "./Components/Reports/AttendanceReport";
import ClientCategory from "./Components/Masters/ClientCategory";
import ClientDashboard from "./Components/Dashboards/ClientDashboard";
import StaffDashboard from "./Components/Dashboards/StaffDashboard";
import Attendance from "./Components/Staff-info/Attendance";
import AdminDashboard from "./Components/Dashboards/AdminDashboard";
import AttendanceList from "./Components/Staff-info/Attendancelist";
import PayoutReport from "./Components/Reports/PayoutReport";
import PaymentReport from "./Components/Reports/PaymentReport";
import Payment from "./Components/Client-Info/Payment";
import ClientPayment from "./Components/Client-Info/ClientPayment";
import Folder from "./Components/Folders/Folder";
import SubFolder from "./Components/Folders/SubFolder";
import File from "./Components/Folders/File";
import ClientFolder from "./Components/Folders/ClientFolder";
import FileUpload from "./Components/Masters/ImportClients";
import LoginHistory from "./Components/Masters/LoginHistory";
import SubAdminDashboard from "./Components/Dashboards/SubAdminDashboard";
import GenerateTasks from "./Components/Services/GenerateTasks";
import AllClients from "./Components/Client-Info/AllClients";
import Clients from "./Components/Client-Info/Clients";
import ServiceTaskReport from "./Components/Reports/ServiceTaskReport";
import Company from "./Components/Masters/CompanyDetails";
import IPAddress from "./Components/Masters/IPAddress";
import ChangePassword from "./Authentication/ChangePassword";
import SystemTask from "./Components/Masters/SystemTask";
import ServiceTaskList from "./Components/Services/ServiceTaskList";

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path="/" element={<Login />} />
        {/* <Route path="/login" element={<Login />} /> */}
        <Route path="/logout" element={<Logout />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/category" element={<Category />} />
        <Route path="/clientservice" element={<ClientService />} />
        <Route path="/designation" element={<Designation />} />
        <Route path="/staff" element={<Staff />} />
        <Route path="/overtime" element={<OverTime />} />
        <Route path="/attendance" element={<Attendance />} />
        <Route path="/salary" element={<Salary />} />
        <Route path="/attendancereport" element={<AttendanceReport />} />
        <Route path="/clientcategory" element={<ClientCategory />} />
        <Route path="/clientdashboard" element={<ClientDashboard />} />
        <Route path="/staffdashboard" element={<StaffDashboard />} />
        <Route path="/servicetasklist" element={<ServiceTaskList />} />
        <Route path="/admindashboard" element={<AdminDashboard />} />
        <Route path="/attendancelist" element={<AttendanceList />} />
        <Route path="/payoutreport" element={<PayoutReport />} />
        <Route path="/payment" element={<Payment />} />
        <Route path="/paymentreport" element={<PaymentReport />} />
        <Route path="/clientpayment" element={<ClientPayment />} />
        <Route path="clientfolder" element={<ClientFolder />} />
        <Route path="/clientfolder/:clientId" element={<Folder />} />
        <Route path="/folder/:folderId" element={<SubFolder />} />
        <Route path="/file/:folderId" element={<File />} /> {/* File page */}
        <Route path="importclients" element={<FileUpload />} />
        <Route path="ipaddress" element={<IPAddress />} />
        <Route path="loginhistory" element={<LoginHistory />} />
        <Route path="subadmindashboard" element={<SubAdminDashboard />} />
        <Route path="generatetasks" element={<GenerateTasks />} />
        <Route path="allclients" element={<AllClients />} />
        <Route path="clients" element={<Clients />} />
        <Route path="servicetaskreports" element={<ServiceTaskReport />} />
        <Route path="companies" element={<Company />} />
        <Route path="changepassword" element={<ChangePassword />} />
        <Route path="systemtask" element={<SystemTask />} />
      </Routes>
    </div>
  );
}

export default App;
